<template>
  <div><!-- this is inserted into ClaimForms.vue-->
    <div class="c-card--claim-forms__body">

      <div v-if="submitError" class="c-validation t-alert-danger u-margin-bottom-10">
        <p>{{ $t('web.card_claims_submitter.submit_error') }}</p>
      </div>

      <form autocomplete="off">
        <h3 class="u-h1 u-no-top-margin">{{ forms[formIndex].name }}</h3>

        <p v-if="forms[formIndex].description">{{ forms[formIndex].description }}</p>

        <fieldset
          v-for = "field in forms[formIndex].fields"
          class = "o-fieldset c-card--claim-forms__fieldset"
        >
          <component
            v-model = "model[field.name]"
            :is     = "getFieldComponentType(field)"
            :field  = "field"
            :errors = "errors"
            :template = "'edit'"
          >
          </component>

          <div v-for="error in errors[field.name]">
            <div class="c-validation t-alert-danger">{{ error }}</div>
          </div>
        </fieldset>
      </form>
    </div>

    <div class="c-card--claim-forms__footer">
      <button
        @click    = "cancel"
        :disabled = "processingForm"
        ref       = "cancelButton"
        class     = "c-button t-button-plain qa-cancel"
      >
        {{ $t('web.form_detail.cancel_button') }}
      </button>

      <button
        @click    = "submit"
        :disabled = "processingForm"
        ref       = "submitButton"
        class     = "c-button
                     c-card--claim-forms__footer__button
                     t-button-primary
                     qa-submit-this-claim"
      >
        {{ $t('web.form_detail.submit_button') }}
      </button>
    </div>
  </div>
</template>




<script>
import API from '@/services'
import _ from 'lodash'
import $ from 'jquery'
import util from '@/functions'
import FieldCurrency from '../fields/FieldCurrency'
import FieldVarchar from '../fields/FieldVarchar'
import FieldEmail from '../fields/FieldEmail'
import FieldDate from '../fields/FieldDate'
import FieldInteger from '../fields/FieldInteger'
import FieldDecimal from '../fields/FieldDecimal'
import FieldPercent from '../fields/FieldPercent'
import FieldBool from '../fields/FieldBool'
import FieldEnum from '../fields/FieldEnum'
import FieldFileUpload from '../fields/FieldFileUpload'

export default {
  props: ['forms', 'formIndex'],

  data () {
    return {
      model: {},
      errors: {},
      submitError: false,
      processingForm: false,
      dataToBeSaved: {}
    }
  },

  components: {
    fieldCurrency: FieldCurrency,
    fieldVarchar: FieldVarchar,
    fieldEmail: FieldEmail,
    fieldDate: FieldDate,
    fieldDecimal: FieldDecimal,
    fieldInteger: FieldInteger,
    fieldPercent: FieldPercent,
    fieldBool: FieldBool,
    fieldEnum: FieldEnum,
    fieldFileUpload: FieldFileUpload
  },

  mounted () {
    this.model = _.cloneDeep(this.forms[this.formIndex].field_values)
  },

  methods: {
    getFieldComponentType (field) {
      return 'field-' + _.replace(field.type, '_', '-')
    },

    validateForm () {
      // create a reactive array of error messages for each field
      _.each(this.forms[this.formIndex].fields, (item) => {
        this.$set(this.errors, item.name, null)
      })
      let valid = true
      _.each(this.forms[this.formIndex].fields, (field, i) => {
        let error = util.validateField(field, this.model[field.name], $(this.$children[i].$refs.input)[0])
        if (error !== '') {
          this.errors[field.name] = [error]
          valid = false
        }
      })
      return valid
    },

    cancel () {
      this.$parent.$emit('cancelled-form')
    },

    submit () {
      if (this.validateForm()) {
        this.processingForm = true
        let formData = new FormData()
        let hasFiles = false
        this.dataToBeSaved = util.getDataToBeSaved(this.forms[this.formIndex].fields, this.model)
        formData.append('fields', JSON.stringify(this.dataToBeSaved))
        formData.append('form_id', this.forms[this.formIndex].id)
        _.each(this.forms[this.formIndex].fields, (field, i) => {
          if (field.type === 'file_upload') {
            hasFiles = true
          }
        })
        if (hasFiles) {
          // validate the form first
          API.postAuthenticated('claim-forms/validate', formData)
          .then((response) => {
            this.sendFormData(formData)
          })
          .catch(this.processAPIError)
        } else {
          this.sendFormData(formData)
        }
      }
    },

    sendFormData (formData) {
      _.each(this.forms[this.formIndex].fields, (field, i) => {
        if (field.type === 'file_upload') {
        // get the files for upload
          let files = this.$children[i].$refs.dropzone.getAddedFiles()
          _.each(files, (file) => {
            formData.append(field.name + '[]', file)
          })
        }
      })

      this.submitError = false

      API.postAuthenticated('claim-forms', formData)
      .then((response) => {
        this.$parent.$emit('submitted-form')
      })
      .catch(this.processAPIError)
    },

    processAPIError (error) {
      this.processingForm = false
        // server-side validation
      if (error.response && error.response.status === 400) {
        for (var field in error.response.data.errors) {
          this.errors[field] = error.response.data.errors[field]
        }
      } else {
        this.submitError = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormDetail.vue?9b0844c4